import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { CommonMessages, NativeAppService, NativeEventType, NavigationService, Page, trackByProp } from '@frontend/vanilla/core';

import { LanguageItemComponent } from './language-item.component';
import { LanguageSwitcherTrackingService } from './language-switcher-tracking.service';
import { LanguageSwitcherItem } from './language-switcher.models';
import { LanguageSwitcherService } from './language-switcher.service';

@Component({
    imports: [CommonModule, LanguageItemComponent],
    selector: 'vn-language-switcher-radio-menu',
    templateUrl: 'language-switcher-radio-menu.html',
})
export class LanguageSwitcherRadioMenuComponent implements OnInit {
    languageSwitcherService = inject(LanguageSwitcherService);
    commonMessages = inject(CommonMessages);
    private page = inject(Page);
    private languageSwitcherTrackingService = inject(LanguageSwitcherTrackingService);
    private nativeAppService = inject(NativeAppService);
    private navigationService = inject(NavigationService);

    readonly trackByNativeName = trackByProp<LanguageSwitcherItem>('nativeName');

    ngOnInit() {
        this.languageSwitcherTrackingService.trackDisplay(true);
    }

    change(lang: LanguageSwitcherItem) {
        this.nativeAppService.sendToNative({
            eventName: NativeEventType.LANGUAGEUPDATED,
            parameters: { newLanguage: lang.culture, routeValue: lang.routeValue },
        });

        this.languageSwitcherTrackingService.trackChangeLanguage(true, this.page.lang, lang.routeValue).then(() => {
            this.navigationService.goTo(lang.url);
        });
    }
}
